<template>
  <div id="app">
    <sc-menu  :largescreen="largescreen" :key="$route.fullPath"/>
    <!-- <br> Window width: {{ windowWidth }} <br/> -->
    <!-- {{ txt }} -->

    <!-- To prevent slider from stopping when switching to other page-->
    <keep-alive>
      <transition name="fade" mode="out-in">
        <router-view :largescreen="largescreen" :key="$route.fullPath"/>
      </transition>
    </keep-alive>
  </div>
</template>

<script>
 // Imports
 // import $ from "jquery";
 import scMenu from '@/components/scMenu.vue';

 export default {
   components: {
     'sc-menu': scMenu
     // lazy loading
     // 'sc-menu': () => import ("@/components/scMenu.vue")
   },

   data () {
     return {
       largescreen: true,
       windowWidth: 0,
       txt: ''
     }
   },

   watch: {
     windowWidth(newWidth, oldWidth) {
       var $window = $(window),
           $topmenu = $('.menu-section');

       this.txt = `it changed to ${newWidth} from ${oldWidth} largescreen ${this.largescreen}`;
       if (this.windowWidth < 600) {
         this.largescreen = false;
         /* $topmenu.addClass('hide'); */
       } else {
         this.largescreen = true;
         /* $topmenu.removeClass('hide'); */
       }
     }
   },
   mounted() {
     this.windowWidth = window.innerWidth;
     this.$nextTick(() => {
       window.addEventListener('resize', () => {
         this.windowWidth = window.innerWidth
       });
     });
     $(".menubutton").click(function(){
       /* $(".menu-section").toggleClass("hide"); */
     });
     if (this.windowWidth < 600) {
       /* $('.menu-section').addClass('hide'); */
       this.largescreen = false;
     };
     console.log(`[App.vue] mounted: windowWidth is ${this.windowWidth}`);
     console.log(`[App.vue] mounted: largescreen is ${this.largescreen}`);
   },
 }
</script>


<style lang="scss">
 /* @import "../public/assets/scss/base.scss"; */
 @import "../public/assets/scss/layout.scss";
 @import "../public/assets/scss/typography.scss";
 @import "../public/assets/scss/nav-base.scss";
 @import "../public/assets/scss/nav-single-level.scss";
 @import "../public/assets/scss/nav-advanced.scss";
 /* @import "./assets/assets/css/base2.scss"; */
 /* @import "./assets/assets/css/module2.scss"; */
 /* @import "./assets/assets/css/page_home.scss"; */
 /* @import "../public/assets/scss/style.scss"; */

</style>

<style lang="scss" scoped>
 .fade-enter-active, .fade-leave-active {
   transition: opacity .3s;
 }
 .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
   opacity: 0;
 }
</style>
